// @ts-strict-ignore
import { IOperation } from './i-operation';
import { DrillingholePresetVO } from '@project/actions/drilling-hole/drilling-hole.vo';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { DrillingHolePresetPresenter } from '@3d-scene/model3d/util/drillinghole/presenter/drilling-hole-preset.presenter';

export class UndoChangeDrillingHolesOffsetOperation implements IOperation {
  private _drillingHoleOffset: number;
  private _cachedDrillingHoleOffset: number;
  private _drillingHolePresetVO: DrillingholePresetVO;
  private _isPreset: boolean;

  constructor(
    private _mountingRailArticleUsage: ArticleUsageVO,
    private _mountingRailLength: number,
    drillingHoleOffset: number,
    cachedDrillingHoleOffset: number,
    drillingHolePreset: DrillingholePresetVO,
    private _drillingHolePresetPresenter: DrillingHolePresetPresenter
  ) {
    if (
      ArticleUsageUtils.getArticleUsageInfoPropertyBooleanValue(this._mountingRailArticleUsage, ArticleUsageInfoPropertyDef.HAS_DRILLINGHOLE_PRESET)
    ) {
      this._drillingHoleOffset = drillingHoleOffset;
      this._cachedDrillingHoleOffset = cachedDrillingHoleOffset;
      this._drillingHolePresetVO = drillingHolePreset;
      this._isPreset = true;
    }
  }

  public getOperationDescription(): string {
    return '';
  }

  public getQualifiedClassName(): string {
    return 'UndoChangeDrillingHolesOffsetOperation';
  }

  public async performRedo(): Promise<void> {
    if (this._isPreset) {
      await this._drillingHolePresetPresenter.updateDrillingHoles(
        this._mountingRailArticleUsage,
        this._mountingRailLength,
        0,
        0,
        this._drillingHoleOffset,
        this._drillingHoleOffset - this._cachedDrillingHoleOffset,
        this._drillingHolePresetVO,
        false
      );
    }
  }

  public async performUndo(): Promise<void> {
    if (this._isPreset) {
      await this._drillingHolePresetPresenter.updateDrillingHoles(
        this._mountingRailArticleUsage,
        this._mountingRailLength,
        0,
        0,
        this._cachedDrillingHoleOffset,
        this._cachedDrillingHoleOffset - this._drillingHoleOffset,
        this._drillingHolePresetVO,
        false
      );
    }
  }
}
